<template>
  <div id="school-header">
    <div class="top-wrapper"></div>
    <div class="school-info">
      <img @click="jumpSchool(schoolInfo.schoolId)"
        v-if="schoolInfo.schoolBadgeUrl"
        :src="schoolInfo.schoolBadgeUrl"
        class="schoolLogo"
      >
      <div class="school-product">
        <h2>{{schoolInfo.schoolName}}</h2>
        <p>{{schoolInfo.schoolDesc}}</p>
      </div>
      <ul class="login-info">
        <li><a href="//www.g12e.org/">中小学教育联盟首页</a></li>
        <li><a href="//ssjx.g12e.org/">双师教学首页</a></li>
        <li
          class="logged"
          v-if="isLogged"
          @click="logout()"
        >Hi,{{nickName}}<i class="logoutBtn">退出</i></li>
        <li
          class="unlogin"
          v-else
          @click="$SignIn()"
        >登录</li>
      </ul>
    </div>
  </div>
</template>
<script>
import { $Cookies } from '@/utils';
import { getUserInfo } from '@/api/user';
import { isLoginApi } from '@/api/auth';

export default {
  name: 'AppHeader',
  data () {
    return {
      isLogged: false,
      userName: '',
      nickName: '',
      defaultLogo: require('@/assets/images/common/schoolLogo.png')
    };
  },
  computed: {
    schoolInfo () {
      return this.$store.state.schoolInfo.schoolInfo;
    }
  },
  async created () {
    //判断是否登录
    isLoginApi().then(data => {
      if (data.result.isLogin) {
        this.isLogged = true;
      } else {
        this.isLogged = false;
      }
    })
    const uid = $Cookies.get('uid');
    const username = $Cookies.get('username');
    if (uid) {
      await getUserInfo(uid).then(data => {
        if (data.success) {
          this.nickName = data.result.nickName ? data.result.nickName : username;
          if (this.nickName.length > 3) {
            this.nickName = this.nickName.substr(0, 3) + '...'
          }
        } else {
          this.$message.error(data.errorMsg)
        }
      })
    }
  },
  methods: {
    //退出
    logout () {
      const me = this;
      me.$store.dispatch('auth/logout').then(data => {
        if (data.isLogout) {
          me.$message({
            type: 'success',
            message: '退出登录成功',
            duration: 1000,
            onClose: () => {
              window.location.href = '//ssjx.g12e.org';
            }
          });
        }
      });
    },
    //跳转学校主页
    jumpSchool (schoolId) {
      let { href } = this.$router.resolve({
        path: `/school/` + schoolId,
      });
      window.open(href, '_blank');
    }
  }
};
</script>
